// ====================================================
// src/components/block/liveStreamManagement/enchainements/RecouvrementEnchainement.tsx
//
// Le flux "final" actuel reste FIXE ; le flux "preview" glisse par-dessus
// depuis la direction choisie et le recouvre entièrement à progress=1.
// Contrairement à Poussé, le sortant ne bouge pas. Direction réglable via
// DirectionPicker (même config, même widget que Poussé).
// ====================================================

import React from 'react';
import { Enchainement, EnchainementControlProps, EnchainementRenderInput } from './Enchainement';
import { DirectionConfig, DEFAULT_DIRECTION_CONFIG, directionOffset } from './directionUtils';
import DirectionPicker from './DirectionPicker';

class RecouvrementEnchainementImpl extends Enchainement<DirectionConfig> {
  readonly id = 'recouvrement';
  readonly label = 'Recouvrement';
  readonly icon = 'Layers';
  readonly defaultConfig: DirectionConfig = DEFAULT_DIRECTION_CONFIG;

  render(input: EnchainementRenderInput, config: DirectionConfig): void {
    const { ctx, currentSource, currentRect, nextSource, nextRect, progress, width, height } = input;
    const { x: ox, y: oy } = directionOffset(config.angleDeg, width, height);

    // Le flux final reste immobile, plein cadre — rien ne le pousse.
    ctx.drawImage(currentSource, currentRect.x, currentRect.y, currentRect.w, currentRect.h);

    // Le preview arrive d'un plein cadre en arrière et vient recouvrir.
    ctx.save();
    ctx.translate((progress - 1) * ox, (progress - 1) * oy);
    ctx.drawImage(nextSource, nextRect.x, nextRect.y, nextRect.w, nextRect.h);
    ctx.restore();
  }

  renderControls({ config, onChange }: EnchainementControlProps<DirectionConfig>): React.ReactNode {
    return (
      <DirectionPicker
        angleDeg={config.angleDeg}
        onChange={angleDeg => onChange({ angleDeg })}
      />
    );
  }
}

export const recouvrementEnchainement = new RecouvrementEnchainementImpl();
